export const QUICKSWAP_LINK =
  'https://legacy.quickswap.exchange/#/swap?outputCurrency=0xd6d3B4254B4526c3095d8AB00B75f186c56dD72C'

export const unwantedPoolAddresses = [].map((v) => v.toLowerCase())

export const poolsWithPriceInBNB: {
  [key: string]: {
    publicPrice: number
    privatePrice: number
    name: string
  }
} = {}

export const USDB_DECIMALS = 18
export const USDC_DECIMALS = 6

interface NetworkConfig {
  net: string
  accessContractAddress?: string
  adminsContractAddress: string
  lpTokenContractAddress: string
  stakingContractAddress: string
  stakingV1ContractAddress: string
  masterContractAddress: string
  routerContractAddress: string
  wbnbContractAddress: string
  airdropsContractAddress: string
  airdropRewardsContractAddress: string
  maticRewards: string
  ethRewards: string
  bscRewards: string
  usdcContractAddress: string
  stakingOld?: string
  superchargeContractAddress: string
  networkVersion: number
  networkRpcLink: string
  baseBscscanUrl: string
  baseBscscanApiUrl: string
  mint500kBtn: boolean
}

export const networks = {
  testnet: 'testnet',
  mainnet: 'mainnet',
}

const testnetConfig: NetworkConfig = {
  net: networks.testnet,
  stakingOld: '0x619AD7b5cBf74eF5F395b5bEe8302daFB5d6D481',
  accessContractAddress: '0xb3e933C22D3eF3CEd2eBAb0FE45d413344eB4ceE',
  adminsContractAddress: '0xF41590E06a98bff9dce7ca14C8D048785DBAA66D',
  lpTokenContractAddress: '0x6395Ec7295a362f076F2352E8Eb11d5B2A2fAC31',
  stakingContractAddress: '0xc8ec3454aaD19545d5f51Cd5050a7AE00432ce35',
  stakingV1ContractAddress: '0xf3633A7d037E12B326B57aAFa98ccACCc9cFB7D7',
  routerContractAddress: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff',
  masterContractAddress: '0x7457a413F79CBa01EeC0a29Ec2C55FEC0B37b2b6',
  wbnbContractAddress: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
  airdropsContractAddress: '0x7960fa91B0F00Dd0c18B932032017473eaA03693',
  airdropRewardsContractAddress: '0xE4db8381a1D8A6a08cd363A226206bBFFba0f750',
  maticRewards: '0x9Ff3Fa1b709EbC258717b47cC3C3A404C863c797',
  ethRewards: '0xAcD4989C12fC8C2D4d139b39Bf8F59Ad70981961',
  bscRewards: '0xAcD4989C12fC8C2D4d139b39Bf8F59Ad70981961',
  superchargeContractAddress: '0x123540C7AC84d81DbCaA287A006cA3e4D26BB508',
  usdcContractAddress: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  networkVersion: 84532,
  networkRpcLink:
    'https://polygon-mumbai.g.alchemy.com/v2/cntlzb4kJT-9BFLrGaSrei-_ZdB6HpkH',
  baseBscscanUrl: 'https://testnet.bscscan.com',
  baseBscscanApiUrl: 'https://api-testnet.bscscan.com',
  mint500kBtn: true,
}

const mainnetConfig: NetworkConfig = {
  net: networks.mainnet,
  stakingOld: '0x619AD7b5cBf74eF5F395b5bEe8302daFB5d6D481',
  accessContractAddress: '0xb3e933C22D3eF3CEd2eBAb0FE45d413344eB4ceE',
  adminsContractAddress: '0xF41590E06a98bff9dce7ca14C8D048785DBAA66D',
  lpTokenContractAddress: '0x6395Ec7295a362f076F2352E8Eb11d5B2A2fAC31',
  stakingContractAddress: '0xc8ec3454aaD19545d5f51Cd5050a7AE00432ce35',
  stakingV1ContractAddress: '0xf3633A7d037E12B326B57aAFa98ccACCc9cFB7D7',
  routerContractAddress: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff',
  masterContractAddress: '0x7457a413F79CBa01EeC0a29Ec2C55FEC0B37b2b6',
  wbnbContractAddress: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
  airdropsContractAddress: '0x7960fa91B0F00Dd0c18B932032017473eaA03693',
  airdropRewardsContractAddress: '0xE4db8381a1D8A6a08cd363A226206bBFFba0f750',
  maticRewards: '0x9Ff3Fa1b709EbC258717b47cC3C3A404C863c797',
  ethRewards: '0xAcD4989C12fC8C2D4d139b39Bf8F59Ad70981961',
  bscRewards: '0xAcD4989C12fC8C2D4d139b39Bf8F59Ad70981961',
  superchargeContractAddress: '0x123540C7AC84d81DbCaA287A006cA3e4D26BB508',
  usdcContractAddress: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  networkVersion: 8453,
  networkRpcLink: 'https://polygon-rpc.com/',
  baseBscscanUrl: 'https://polygonscan.com/',
  baseBscscanApiUrl: 'https://api.polygonscan.com/',
  mint500kBtn: false,
}

const curNetwork = process.env.REACT_APP_NETWORK || networks.testnet
if (curNetwork !== networks.mainnet && curNetwork !== networks.testnet)
  throw new Error('REACT_APP_NETWORK must be "mainnet" or "testnet"')
const config: NetworkConfig =
  curNetwork === networks.mainnet ? mainnetConfig : testnetConfig

export { config }
